export enum TitlesEnum {
    DARK_ROAST = "Dark Roast",
    PASTEL_BLOOM = "Pastel Bloom",
    WHITE_LATTE = "White Latte",
    BRIGHT_YELLOW = "Bright Yellow",
}
